import * as React from "react";
import { BlogMetaPaper } from "../common/BlogMetaPaper";
import { MetaTitle } from "../common/MetaTitle";
import { Box, Button, TextField } from "@mui/material";

export interface IBlogMetaSearchProps {}

export function BlogMetaSearch(props: IBlogMetaSearchProps) {
  return (
    <BlogMetaPaper>
      <MetaTitle text="Search Blog" />
      <Box
        sx={{ marginTop: "16px", justifyContent: "center", display: "flex" }}
      >
        <TextField
          label="Search Query..."
          variant="outlined"
          size="small"
          sx={{ marginRight: "8px" }}
        />{" "}
        <Button variant="contained" sx={{ fontWeight: "bold" }}>
          search
        </Button>
      </Box>
    </BlogMetaPaper>
  );
}
